import { __spreadArray } from '../../node_modules/tslib/tslib.es6.js';

/* eslint-disable no-console */
var verboseLogging = false;
var enableVerboseLogging = function () {
    verboseLogging = true;
};
var disableVerboseLogging = function () {
    verboseLogging = false;
};
var logIfVerbose = function (message) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (verboseLogging) {
        console.log.apply(console, __spreadArray([message], args, false));
    }
};
var errorIfVerbose = function (message) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (verboseLogging) {
        console.error.apply(console, __spreadArray([message], args, false));
    }
};

export { disableVerboseLogging, enableVerboseLogging, errorIfVerbose, logIfVerbose };
